<template>
  <div class="Admission" v-if="config.bind_key1">
    <!-- <a-layout> -->
    <div class="admissionHeader">
      <img class="topBackImg" :src="backImgUrl" alt="" />
      <img class="zslogo" :src="logoUrl" alt="" />
      <div class="loginBtn">{{ config.header_hint }}</div>
    </div>
    <div class="admissionContent" :style="contentStyle">
      <!-- <img
        class="bgImg"
        :src="config.bgimg ? config.bgimg : '../image/background.png'"
        alt=""
      /> -->
      <div class="formBox" v-if="!queryResult.structure">
        <div class="formTitle">{{ config.query_name }}</div>
        <div class="formDiv">
          <div class="inputBox">
            <img class="inputIcon" src="../image/idIcon.png" alt="" />
            <input class="formInput" v-model="value1" :placeholder="'请输入' + config.bind_key1_name" />
          </div>
          <div class="inputBox">
            <img class="inputIcon" src="../image/nameIcon.png" alt="" />
            <input class="formInput" v-model="value2" :placeholder="'请输入' + config.bind_key2_name" />
          </div>
          <div class="inputBox">
            <img class="inputIcon" src="../image/yzmIcon.png" alt="" />
            <input class="formInput" v-model="challenge" placeholder="请输入验证码" />
            <img class="verificationCode" :src="codeSrc" alt="" @click="codeSrc = '/captcha.html?' + Math.random()" />
          </div>
        </div>
        <div class="btnBox">
          <div class="resetBtn" @click="reset()">重置</div>
          <div class="queryBtn" @click="queryClick()">查询</div>
        </div>
        <div class="tipBox">
          <div v-html="config.query_prompt"></div>
        </div>
      </div>

      <div class="formBox" v-else>
        <div class="formTitle">{{ config.result_title }}</div>
        <div class="resultBox">
          <div class="infoCard" v-for="(title, tIndex) in Object.keys(queryResult.structure)" :key="tIndex">
            <div class="infoItem" v-for="(item, index) in queryResult.structure[title]" :key="index">
              <div class="infoTitle" v-if="queryResult.admission_data[item]">
                {{ queryResult.field_map[item] }}:
              </div>
              <div class="infoContent" v-if="queryResult.admission_data[item]">
                {{ queryResult.admission_data[item] }}
              </div>
            </div>
          </div>

          <!-- <div
            class="infoCard"
            
          >
           <div
              class="infoItem"
            >
              <div class="infoTitle" >
                录取专业取专
              </div>
              <div class="infoContent" >
                录取专业录取专
              </div>
            </div>
            <div
              class="infoItem"
            >
              <div class="infoTitle" >
                录取专业
              </div>
              <div class="infoContent" >
                录取专业录取专业录取专业录取专业录取专业录取专业录取专业录取专业
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="admissionFooter">
      <div class="footerBox">
        <div class="qrCodeBox">
          <div class="qrCode">
            <img class="qrCodeImg" :src="config.qrcode_wxoa" alt="" />
            <div class="qrName">微信公众号</div>
          </div>
          <div class="qrCode">
            <img class="qrCodeImg" :src="config.qrcode_wxapp" alt="" />
            <div class="qrName">微信小程序</div>
          </div>
        </div>
        <div class="copyright">{{ config.copyright }}</div>
        <div class="qrCodeBoxRight">
          <div class="qrCode">
            <img class="qrCodeImg" :src="config.qrcode_baiduapp" alt="" />
            <div class="qrName">百度小程序</div>
          </div>
          <div class="qrCode">
            <img class="qrCodeImg" :src="config.qrcode_bytedanceapp" alt="" />
            <div class="qrName">抖音小程序</div>
          </div>
        </div>
      </div>
    </div>
    <!-- </a-layout> -->
  </div>
</template>
<script>
export default {
  name: 'Admission',
  data() {
    return {
      value1: '',
      value2: '',
      challenge: '',
      codeSrc: '/captcha.html',
      config: {},
      queryResult: {},
      logoUrl: '',
      backImgUrl: '',
      contentStyle: {}
    }
  },
  created() {
    this.isMobile()
    this.getConfig()
    this.getLogo()
    this.getTopBackground()
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if (flag) {
        location.href = '#'
      }
    },
    getConfig() {
      this.$axios({
        url: '/api/grade/getConfig',
        method: 'get'
      }).then(res => {
        this.config = res.data
        document.title = this.config.query_name
        this.contentStyle = {
          background: `url(${this.config.bgimg})  no-repeat`,
          backgroundSize: 'cover'
        }
      })
    },
    getLogo() {
      this.$axios({
        url: ' /api/logo/get?key=pc_admission_logo_03',
        method: 'get'
      }).then(res => {
        this.logoUrl = res.data
      })
    },
    getTopBackground() {
      this.$axios({
        url: ' /api/logo/get?key=pc_admission_logo_04',
        method: 'get'
      }).then(res => {
        this.backImgUrl = res.data
      })
    },
    reset() {
      this.value1 = ''
      this.value2 = ''
      this.codeSrc = '/captcha.html?' + Math.random()
    },
    queryClick() {
      // /web_query?challenge=CHALLENGE
      if (this.value1 === '' || this.value2 === '') {
        this.$warning({
          title: '',
          content: '请输入查询信息'
        })
        this.codeSrc = '/captcha.html?' + Math.random()
        return
      }
      if (this.challenge === '') {
        this.$warning({
          title: '',
          content: '请输入验证码'
        })
        this.codeSrc = '/captcha.html?' + Math.random()
        return
      }
      let params = {
        [this.config.bind_key1]: this.value1,
        [this.config.bind_key2]: this.value2
      }
      this.$axios({
        url: '/api/grade/web_query?challenge=' + this.challenge,
        method: 'post',
        data: {
          challenge: this.challenge,
          query: JSON.stringify(params)
        }
      })
        .then(res => {
          console.log(res)
          this.codeSrc = '/captcha.html?' + Math.random()
          if (res.code === 0) {
            this.queryResult = res.data
          } else {
            // empty_return_prompt
            this.$warning({
              title: '',
              content: res.msg
            })
          }
        })
        .catch(err => {
          this.codeSrc = '/captcha.html?' + Math.random()
        })
    }
  }
}
</script>
<style lang="less" >
@media screen and (max-width: 540px) {
  .ant-modal {
    top: 20%;
    left: 10%;
    padding-top: 80px;
    border-radius: 16px;
    .anticon {
      font-size: 80px;
      line-height: 80px;
    }
    .ant-modal-content {
      border-radius: 16px;
      padding: 80px;
      height: 800px;
      width: 80%;
      font-size: 48px;
      line-height: 48px;
      .ant-modal-confirm-content {
        height: 400px;
      }
    }
    .ant-btn {
      height: 150px;
      width: 300px;
      border-radius: 16px;
    }
  }
}
.Admission {
  width: 100%;
  .admissionHeader {
    width: 100%;
    height: 114px;
    position: relative;
    display: flex;
    justify-content: space-between;
    .topBackImg {
      width: 100%;
      height: 114px;
      position: absolute;
      top: 0;
      left: 0;
    }
    .zslogo {
      width: 248px;
      height: 63px;
      margin: 24px 0 0 18%;
      z-index: 50;
    }
    .loginBtn {
      // width: 64px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 22px;
      margin: 48px 19% 0 0;
      z-index: 60;
    }
  }
  .admissionContent {
    // background: url(../image/background.png) no-repeat;
    height: 755px;
    @media screen and (max-width: 540px) {
      height: 3000px;
    }
    position: relative;
    .bgImg {
      width: 100%;
    }
    .formBox {
      width: 520px;
      height: 640px;
      background: #ffffff;
      border-radius: 8px;
      position: absolute;
      top: 57px;
      left: 54%;
      padding: 0 40px;
      padding-top: 56px;
      @media screen and (max-width: 540px) {
        height: 55%;
        width: 70%;
        position: relative;
        left: 15%;
        top: 10%;
        border-radius: 16px;
        padding: 0 80px;
        padding-top: 200px;
      }
      .formTitle {
        width: 100%;
        height: 33px;
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #2a2a2a;
        line-height: 33px;
        text-align: center;
        @media screen and (max-width: 540px) {
          font-size: 72px;
        }
      }
      .formDiv {
        margin-top: 56px;
        @media screen and (max-width: 540px) {
          margin-top: 160px;
        }
        .inputBox {
          width: 440px;

          height: 48px;
          border-radius: 4px;
          border: 1px solid #d3d3d3;
          overflow: hidden;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
          margin-bottom: 24px;
          @media screen and (max-width: 540px) {
            width: 99%;
            height: 144px;
            margin-bottom: 48px;
            border: 3px solid #d3d3d3;
            border-radius: 12px;
          }
          .inputIcon {
            width: 24px;
            height: 24px;
            margin: 12px;
            margin-right: 8px;
            @media screen and (max-width: 540px) {
              width: 72px;
              height: 72px;
              margin-right: 16px;
            }
          }
          .formInput {
            border: none;
            width: 390px;
            height: 48px;
            line-height: 48px;
            font-size: 16px;
            @media screen and (max-width: 540px) {
              width: 100%;
              height: 144px;
              font-size: 48px;
            }
          }
          input:focus {
            outline: none;
          }
          .verificationCode {
            width: 100px;
            height: 40px;
            margin-right: 8px;
            @media screen and (max-width: 540px) {
              width: 200px;
              height: 120px;
              margin-right: 16px;
            }
          }
        }
      }
      .btnBox {
        display: flex;
        justify-content: space-between;
        div {
          width: 200px;
          height: 48px;
          border-radius: 4px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 48px;
          text-align: center;
          cursor: pointer;
          @media screen and (max-width: 540px) {
            width: 500px;
            height: 144px;
            line-height: 156px;
            font-size: 50px;
          }
        }
        .resetBtn {
          background: linear-gradient(180deg, #ffcdcf 0%, #f78c8c 100%);
          color: #9f0a0b;
        }
        .queryBtn {
          background: linear-gradient(180deg, #b01d1e 0%, #960102 100%);
          color: #ffffff;
        }
      }
      .tipBox {
        margin-top: 56px;
        font-size: 14px !important;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #777777;
        line-height: 24px;
        white-space: pre-line;
        @media screen and (max-width: 540px) {
          margin-top: 100px;
          font-size: 36px;
          line-height: 50px;
        }
      }

      .resultBox {
        margin-top: 56px;
        padding: 0 24px;
        @media screen and (max-width: 540px) {
          margin-top: 112px;
          padding: 0 48px;
        }
        .infoCard {
          .infoItem {
            display: flex;
            // align-items: center;
            .infoTitle {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(35, 39, 55, 0.3);
              line-height: 40px;
              width: 125px;
              margin-right: 24px;
              @media screen and (max-width: 540px) {
                font-size: 48px;
                line-height: 100px;
                width: 350px;
              }
            }
            .infoContent {
              width: 90%;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #2a2a2a;
              line-height: 40px;
              @media screen and (max-width: 540px) {
                font-size: 48px;
                line-height: 100px;
              }
            }
          }
        }
      }
    }
  }

  .admissionFooter {
    height: 114px;
    width: 100%;
    background-color: #000000;
    @media screen and (max-width: 540px) {
      height: 360px;
    }
    // position: relative;
    .footerBox {
      width: 100%;
      height: 114px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      text-align: center;
    }
    .qrCodeBox {
      // margin-left: 18;
      // width: 25%;
      position: absolute;
      top: 0;
      left: 362px;
      height: 114px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      @media screen and (max-width: 540px) {
        left: 50px;
        top: 50px;
      }
    }
    .qrCodeBoxRight {
      position: absolute;
      top: 0 !important;
      right: 362px !important;
      height: 114px;
      display: flex;
      align-items: center;
      @media screen and (max-width: 540px) {
        right: 50px !important;
        top: 50px !important;
      }
    }
    .qrCode {
      width: 70px;
      margin: 0 28px;
      text-align: center;
      @media screen and (max-width: 540px) {
        width: 200px;
      }
      .qrCodeImg {
        width: 64px;
        height: 64px;
        display: block;
        margin: 0 auto;
      }
      .qrName {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.85);
        line-height: 20px;
        @media screen and (max-width: 540px) {
          line-height: 60px;
        }
        // margin-top: 10px;
      }
    }
    .copyright {
      // position: absolute;
      // left: 863px;
      // top: 44px;
      // margin-top: 44px;
      margin: 0 auto;
      width: 350px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.85) !important;
      color: #ffffff;
      line-height: 22px;
      @media screen and (max-width: 540px) {
        width: 500px;
        line-height: 40px;
        position: absolute;
        // left: 863px;
        top: 50px;
        // margin-top: 44px;
      }
    }
  }
}
</style>